import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { UbicacionService } from 'src/app/services/ubicacion/ubicacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { Estado, Ciudad } from 'src/app/interfaces/ubicaciones';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { environment } from 'src/environments/environment';
import { ImageType } from '../../../enums/imageType.enum';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { FileType } from 'src/app/enums/fileType.enum';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { Categorias } from 'src/app/interfaces/categorias';
import { Country } from 'src/app/interfaces/country';
import { Countries } from "src/app/shared/country-data-store";

const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const DISPOSABLE_DOMAINS = new Set([
  'mailinator.com','guerrillamail.com','tempmail.com','yopmail.com','dispostable.com',
  'fakeinbox.com','maildrop.cc','sharklasers.com','guerrillamailblock.com','grr.la',
  'guerrillamail.info','guerrillamail.biz','guerrillamail.de','guerrillamail.net',
  'guerrillamail.org','spam4.me','trashmail.com','trashmail.me','trashmail.net',
  'trashmail.at','trashmail.io','getairmail.com','filzmail.com','throwam.com',
  'spamgourmet.com','spamgourmet.net','spamgourmet.org','spam.la','mailnull.com',
  'spaminator.de','spaml.de','mail-temp.com','spambog.com','tempr.email',
  'temp-mail.org','temp-mail.io','discard.email','mohmal.com','tempemail.co',
  'fakemailgenerator.com','tempinbox.com','spamfree24.org','spam.su','spamobox.com',
  'antispam24.de','20minutemail.com','10minutemail.com','10minutemail.net',
  '10minutemail.org','10minutemail.de','mailnesia.com','mailcatch.com','mailsucker.net',
]);

declare const google: any;

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit, OnDestroy {

  // ── 2-step flow ──
  pasoRegistro = 1;
  cargandoSocial = false;
  mensajeErrorSocial = '';
  correoTemporal = false;
  correoYaExiste = false;
  showCanPass = false;
  showCanConfirm = false;
  showEmpPass = false;
  showEmpConfirm = false;

  // ── WhatsApp-first (solo candidato) ──
  waStep: 'idle' | 'phone' | 'otp' | 'confirm' = 'idle';
  selectedDialCode = '521';
  waPhoneNumber = '';
  waPhoneError = '';
  waOtpCode = '';
  waSendingOtp = false;
  waVerifyingOtp = false;
  waOtpError = '';
  waMaskedEmail = '';
  waResolving = false;
  waResendCooldown = 0;
  private waResendTimer: any;

  readonly countries = [
    { dial: '521', display: '52', flag: '🇲🇽' },
    { dial: '1',   display: '1',  flag: '🇺🇸' },
    { dial: '57',  display: '57', flag: '🇨🇴' },
    { dial: '54',  display: '54', flag: '🇦🇷' },
    { dial: '56',  display: '56', flag: '🇨🇱' },
    { dial: '51',  display: '51', flag: '🇵🇪' },
    { dial: '593', display: '593', flag: '🇪🇨' },
    { dial: '58',  display: '58', flag: '🇻🇪' },
    { dial: '598', display: '598', flag: '🇺🇾' },
    { dial: '34',  display: '34', flag: '🇪🇸' },
  ];

  // ── Existing state ──
  captchaIsLoaded: boolean;
  captchaSuccess: boolean;
  captchaIsExpired: boolean;
  captchaResponse: string;
  calveSitio: string;
  lang: string;

  formEmp: FormGroup;
  formCan: FormGroup;
  archivo: File;
  cv: File;
  esImagen: boolean;
  esPdf: boolean;
  pesoLogo: number;
  pesoPDF: number;
  excedePeso: boolean;
  esMensajePass: boolean;
  esMensajeSubmit: boolean;
  mensajeExito: string;
  mensajeError: string;
  estados: Estado[];
  ciudades: Ciudad[];
  categorias: Categorias[];
  tipoRegistro: string;
  enviandoForm: boolean;
  noExisteUsuario: boolean;
  aceptoPrivacidad: boolean;
  mostrarMensajeEmpresa: boolean;
  mostrarMensajeCandidato: boolean;
  validandoCampos: boolean;
  esconderCiudades: boolean;
  paises: Country[];
  pais: string;
  valorCodigoCoinciden: boolean;
  valorPais: string;
  codigoPais: string;
  paisCodigo: number;

  constructor(
    private title: Title,
    private meta: Meta,
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private ubicacionService: UbicacionService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private inicioService: InicioService,
    private authService: AuthService,
    private alertService: AlertService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.agregarMetaData();
    this.cargarComboEstados();
    this.obtenerCategorias();
    this.lang = "es";
    this.captchaIsLoaded = false;
    this.captchaSuccess = false;
    this.captchaIsExpired = false;
    this.calveSitio = environment.siteKey;
    this.esImagen = true;
    this.esPdf = true;
    this.pesoLogo = environment.pesoMaximoLogo;
    this.pesoPDF = environment.pesoMaximoPDF;
    this.excedePeso = false;
    this.esMensajePass = false;
    this.esMensajeSubmit = false;
    this.validandoCampos = false;
    this.esconderCiudades = true;
    this.tipoRegistro = RolesType.EMPRESAS;
    this.enviandoForm = false;
    this.aceptoPrivacidad = false;
    this.mostrarMensajeEmpresa = false;
    this.mostrarMensajeCandidato = false;
    this.paises = Countries;
    this.setValoresPais();
  }

  ngOnInit(): void {
    this.formEmp = this.formBuilder.group({
      correo: [null, [Validators.required, Validators.pattern(correoRegExp)]],
      password: [null, Validators.required],
      confirmarPass: [null, Validators.required],
      nombreComercial: [null],
      razonSocial: [null],
      telefono: [null],
      giroEmpresarial: null,
      estado: 0,
      ciudad: 0,
      direccion: [null],
      rfc: [null, [Validators.pattern(/^[A-Z0-9]*$/), Validators.maxLength(14)]],
      claveEmpresa: [null, Validators.pattern(/^[A-Z0-9]*$/)],
      urlWeb: null,
      descripcion: [null, Validators.maxLength(255)],
      recaptcha: [null, Validators.required]
    });

    this.formCan = this.formBuilder.group({
      correo: [null, [Validators.required, Validators.pattern(correoRegExp)]],
      password: [null, Validators.required],
      confirmarPass: [null, Validators.required],
      nombre: [null, Validators.required],
      apellidos: [null, Validators.required],
      genero: [null],
      telefono: [null, [Validators.pattern(/^[\d]*$/)]],
      estado: 0,
      ciudad: 0,
      categoria: [null],
      recaptcha: [null, Validators.required]
    });

    if (isPlatformBrowser(this.platformId)) {
      this.initGoogleSignIn();
    }

    // Preseleccionar rol (?role=empresa desde FAB, ?role=candidato desde CTA)
    const roleParam = this.route.snapshot.queryParamMap.get('role');
    if (roleParam === 'empresa') {
      this.elegirRol(RolesType.EMPRESAS);
    } else if (roleParam === 'candidato') {
      this.elegirRol(RolesType.CANDIDATOS);
    }
  }

  // ── 2-step registration ───────────────────────────────────────────────────

  ngOnDestroy(): void {
    clearInterval(this.waResendTimer);
  }

  elegirRol(rol: string): void {
    this.tipoRegistro = rol;
    this.pasoRegistro = 2;
    if (isPlatformBrowser(this.platformId)) {
      this.cdr.detectChanges(); // Forzar creación del DOM del *ngIf
      this.renderGoogleButton();
    }
  }

  // ── Google Sign-In ────────────────────────────────────────────────────────

  private googleReady = false;

  private initGoogleSignIn(): void {
    const scriptId = 'google-gsi-script';
    const init = () => {
      this.googleReady = true;
      if (typeof google === 'undefined' || !google?.accounts?.id) return;
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: (response: any) => this.handleGoogleResponse(response, this.tipoRegistro),
      });
      // Si el usuario ya eligió rol antes de que cargara GSI, renderizar ahora
      if (this.pasoRegistro === 2) {
        this.renderGoogleButton();
      }
    };
    if (document.getElementById(scriptId)) { init(); return; }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = init;
    document.head.appendChild(script);
  }

  private renderGoogleButton(): void {
    if (typeof google === 'undefined' || !google?.accounts?.id) return;
    const container = document.getElementById('google-btn-container-register');
    if (!container) return;
    try {
      google.accounts.id.renderButton(container, {
        theme: 'outline',
        size: 'large',
        text: 'continue_with',
        shape: 'rectangular',
        locale: 'es',
        width: Math.max(container.offsetWidth || 380, 280),
      });
    } catch (_e) { /* dominio no autorizado o error de GSI */ }
  }

  private handleGoogleResponse(response: any, rol: string): void {
    if (!response?.credential) return;
    this.cargandoSocial = true;
    this.mensajeErrorSocial = '';
    this.authService.googleLogin(response.credential, rol)
      .then(result => {
        if (result?.data) this.guardarDatosUsuario(result.data);
        else this.mensajeErrorSocial = 'No se pudo crear la cuenta con Google.';
      })
      .catch(() => { this.mensajeErrorSocial = 'Error al registrar con Google. Intenta de nuevo.'; })
      .finally(() => { this.cargandoSocial = false; });
  }

  // ── LinkedIn Sign-In ──────────────────────────────────────────────────────

  loginLinkedIn(rol: string): void {
    const state = Math.random().toString(36).substring(2);
    localStorage.setItem('linkedin_oauth_state', state);
    localStorage.setItem('linkedin_oauth_rol', rol);

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: environment.linkedinClientId,
      redirect_uri: environment.linkedinRedirectUri,
      state,
      scope: 'openid profile email',
    });

    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params}`;
  }

  // ── WhatsApp-first (candidato) ──────────────────────────────────────────────

  get waFullPhone(): string {
    const digits = this.waPhoneNumber.replace(/\D/g, '');
    return this.selectedDialCode + digits;
  }

  onWaPhoneChange(value: string): void {
    this.waPhoneNumber = (value || '').replace(/\D/g, '');
  }

  onWaOtpChange(value: string): void {
    this.waOtpCode = (value || '').replace(/\D/g, '').slice(0, 6);
  }

  openWhatsapp(): void {
    this.waStep = 'phone';
    this.mensajeErrorSocial = '';
  }

  closeWhatsapp(): void {
    this.waStep = 'idle';
    this.waPhoneNumber = '';
    this.waOtpCode = '';
    this.waPhoneError = '';
    this.waOtpError = '';
    clearInterval(this.waResendTimer);
  }

  sendWaOtp(): void {
    const digits = this.waPhoneNumber.replace(/\D/g, '');
    if (digits.length < 7) {
      this.waPhoneError = 'Ingresa un número válido';
      return;
    }
    this.waPhoneError = '';
    this.waSendingOtp = true;
    this.authService.whatsappSendOtp(this.waFullPhone)
      .then(() => {
        this.waSendingOtp = false;
        this.waStep = 'otp';
        this.waOtpCode = '';
        this.waOtpError = '';
        this.startWaResendCooldown();
      })
      .catch(err => {
        this.waSendingOtp = false;
        this.waPhoneError = err?.error?.message || 'Error al enviar código';
      });
  }

  resendWaOtp(): void {
    if (this.waResendCooldown > 0 || this.waSendingOtp) return;
    this.waOtpCode = '';
    this.waOtpError = '';
    this.waSendingOtp = true;
    this.authService.whatsappSendOtp(this.waFullPhone)
      .then(() => {
        this.waSendingOtp = false;
        this.startWaResendCooldown();
      })
      .catch(err => {
        this.waSendingOtp = false;
        this.waOtpError = err?.error?.message || 'Error al reenviar código';
      });
  }

  private startWaResendCooldown(): void {
    clearInterval(this.waResendTimer);
    this.waResendCooldown = 45;
    this.waResendTimer = setInterval(() => {
      this.waResendCooldown--;
      if (this.waResendCooldown <= 0) clearInterval(this.waResendTimer);
    }, 1000);
  }

  verifyWaOtp(): void {
    const code = this.waOtpCode.trim();
    if (code.length < 6) {
      this.waOtpError = 'Ingresa el código completo de 6 dígitos';
      return;
    }
    this.waOtpError = '';
    this.waVerifyingOtp = true;
    this.authService.whatsappVerifyOtp(this.waFullPhone, code)
      .then(result => {
        this.waVerifyingOtp = false;
        if (result?.requiresConfirmation) {
          this.waMaskedEmail = result.maskedEmail || '';
          this.waStep = 'confirm';
          return;
        }
        if (result?.data?.token) {
          this.guardarDatosUsuario(result.data);
        } else {
          this.waOtpError = 'No se pudo verificar. Intenta de nuevo.';
        }
      })
      .catch(err => {
        this.waVerifyingOtp = false;
        this.waOtpError = err?.error?.message || 'Código incorrecto. Solicita uno nuevo.';
        this.waOtpCode = '';
      });
  }

  resolveWa(action: 'LINK' | 'NEW'): void {
    this.waResolving = true;
    this.authService.whatsappResolve(this.waFullPhone, action)
      .then(result => {
        this.waResolving = false;
        if (result?.data?.token) {
          this.guardarDatosUsuario(result.data);
        } else {
          this.waOtpError = 'No se pudo completar. Intenta de nuevo.';
          this.waStep = 'otp';
        }
      })
      .catch(err => {
        this.waResolving = false;
        this.mensajeErrorSocial = err?.error?.message || 'Ocurrió un error. Intenta de nuevo.';
        this.waStep = 'phone';
      });
  }

  // ── Post-auth redirect ────────────────────────────────────────────────────

  private guardarDatosUsuario(data: JwtResponse): void {
    localStorage.setItem('currentUser', JSON.stringify(data));
    this.authService.setCurrentUserValue(data);

    if (!isPlatformBrowser(this.platformId)) {
      this.router.navigate(['/']);
      return;
    }

    if (data.role === RolesType.EMPRESAS && data.user?.perfilCompleto === false) {
      window.location.href = '/completar-empresa';
    } else if (data.role === RolesType.EMPRESAS) {
      window.location.href = '/empresa';
    } else if (data.role === RolesType.CANDIDATOS) {
      if (data.isNew) {
        // Nuevo candidato registrado → free onboarding directo
        window.location.href = '/free-onboarding';
      } else {
        this.decidirRedireccionCandidato(data.user?.idUsuario);
      }
    } else {
      window.location.href = '/';
    }
  }

  /** Candidato legacy sin freebie usado (ni descartado) → free-onboarding en vez de home. */
  private decidirRedireccionCandidato(candidatoId: number | undefined): void {
    if (!candidatoId) { window.location.href = '/'; return; }
    this.alertService.getEstado(candidatoId).subscribe({
      next: (res: any) => {
        const estado = res?.data || res;
        const elegible = !estado?.freebieUsado && !estado?.freebiePromptDismissed;
        window.location.href = elegible ? '/free-onboarding' : '/';
      },
      error: () => { window.location.href = '/'; }
    });
  }

  // ── Disposable email check ────────────────────────────────────────────────

  private isDisposableEmail(email: string): boolean {
    if (!email) return false;
    const domain = email.split('@')[1]?.toLowerCase();
    return DISPOSABLE_DOMAINS.has(domain);
  }

  // ── Registration methods ──────────────────────────────────────────────────

  private agregarMetaData(): void {
    this.title.setTitle('Crear Cuenta Para Empresas');
    this.meta.updateTag({ name: "description", content: "Registrate para tener oportunidad de ver las empresas y candidatos participantes para ayudarte encontrar lo mejor del talento y empleo." });
    this.meta.updateTag({ name: "keywords", content: "registro, empresas, postulaciones, cuenta, vacantes" });
    this.meta.updateTag({ name: "robots", content: "noodp" });
    this.meta.updateTag({ property: "og:title", content: "Crear Cuenta Para Empresas" });
    this.meta.updateTag({ property: "og:description", content: "Registrate para tener oportunidad de ver las empresas y candidatos participantes para ayudarte encontrar lo mejor del talento y empleo." });
    this.meta.updateTag({ property: "og:url", content: environment.baseTG });
    this.meta.updateTag({ property: "og:site_name", content: "TG Empleos" });
    this.meta.updateTag({ property: "og:locale", content: "es_ES" });
    this.meta.updateTag({ property: "og:type", content: "website" });
    this.meta.updateTag({ property: "og:image", content: environment.baseAssets + "/img/sitio-web-de-tg.jpg" });
    this.meta.updateTag({ name: "twitter:title", content: "Crear Cuenta Para Empresas" });
    this.meta.updateTag({ name: "twitter:description", content: "Registrate para tener oportunidad de ver las empresas y candidatos participantes para ayudarte encontrar lo mejor del talento y empleo." });
    this.meta.updateTag({ name: "twitter:site", content: "@tecgurusnet" });
    this.meta.updateTag({ name: "twitter:image", content: environment.baseAssets + "/img/sitio-web-de-tg.jpg" });
    this.meta.updateTag({ name: "twitter:creator", content: "@tecgurusnet" });
    this.meta.updateTag({ name: "twitter:card", content: "summary" });
  }

  setValoresPais(): void {
    this.pais = 'México';
    this.valorPais = 'MX';
    this.codigoPais = 'MX';
    this.paisCodigo = 52;
    this.valorCodigoCoinciden = true;
  }

  seleccionarPais(codigo: string, pais: string): void {
    this.pais = pais;
    this.valorPais = codigo;
    if (this.valorPais != this.codigoPais) {
      this.valorCodigoCoinciden = false;
      this.reiniciarMensajes();
    }
  }

  seleccionarEstado(idEstado: number): void {
    if (idEstado) {
      this.cargarCombociudades(idEstado);
      this.validandoCampos = false;
      this.esconderCiudades = false;
    }
  }

  obtenerCodigoPais(event: any): void {
    console.log('codigp', event);
    this.paisCodigo = event;
    this.codigoPais = event.iso2.toUpperCase();
    this.valorPais = this.codigoPais;
    this.paises.forEach(pa => { if (pa.code == this.valorPais) { this.pais = pa.name; } });
  }

  async cargarComboEstados(): Promise<any> {
    try {
      const response = await this.ubicacionService.obtenerEstados();
      this.estados = response.data;
    } catch (error) {
      console.error("Error al cargar el combo estados.", error);
    }
  }

  async cargarCombociudades(idEstado: number): Promise<any> {
    try {
      const response = await this.ubicacionService.obtenerCiudadesPorEstado(idEstado);
      this.ciudades = response.data;
    } catch (error) {
      console.error("Error al cargar el combo ciudades.", error);
    }
  }

  async obtenerCategorias() {
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      this.categorias = response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  subirArchivo(e: any): void {
    this.archivo = e.target.files[0];
    if (this.archivo.type == ImageType.JPEG || this.archivo.type == ImageType.PNG
      || this.archivo.type == ImageType.ICO || this.archivo.type == ImageType.TIF) {
      this.esImagen = true;
      this.excedePeso = this.archivo.size > this.pesoLogo;
    } else {
      this.esImagen = false;
    }
  }

  subirPdf(e: any): void {
    this.cv = e.target.files[0];
    if (this.cv.type == FileType.PDF) {
      this.esImagen = true;
      this.excedePeso = this.cv.size > this.pesoPDF;
    } else {
      this.esPdf = false;
    }
  }

  async existeUsuarioPorCorreo(correo: string) {
    try {
      const response = await this.usuarioService.obtenerUsuarioExistente(correo);
      return response.data;
    } catch (error) {
      console.error("Error al traer usuario existente", error);
    }
  }

  async crearCuentaEmpresarial() {
    this.mostrarMensajeEmpresa = true;
    this.validandoCampos = true;

    const correo = this.formEmp.value.correo;
    if (correo && this.isDisposableEmail(correo)) {
      this.correoTemporal = true;
      this.esMensajeSubmit = true;
      this.mensajeError = 'Los correos temporales no están permitidos.';
      this.reiniciarMensajes();
      return;
    }
    this.correoTemporal = false;

    if (this.formEmp.controls.correo.invalid || this.formEmp.controls.password.invalid ||
        this.formEmp.controls.confirmarPass.invalid || this.formEmp.controls.recaptcha.invalid) {
      if (!this.aceptoPrivacidad) {
        this.esMensajeSubmit = true;
        this.mensajeError = 'Por favor, acepte los términos y condiciones.';
        this.reiniciarMensajes();
        return;
      }
      this.reiniciarMensajes();
      return;
    }

    if (!this.compararPasswords(this.formEmp.value.password, this.formEmp.value.confirmarPass)) {
      return;
    }

    if (!this.aceptoPrivacidad) {
      this.esMensajeSubmit = true;
      this.mensajeError = 'Por favor, acepte los términos y condiciones.';
      this.reiniciarMensajes();
      return;
    }

    const dataCorreo = await this.existeUsuarioPorCorreo(correo);
    if (dataCorreo) {
      this.correoYaExiste = true;
      this.mensajeError = "Lo sentimos, el correo ya existe. Ingrese otro por favor.";
      this.esMensajeSubmit = true;
      return;
    }

    this.enviandoForm = true;

    const data = {
      correo: this.formEmp.value.correo,
      password: this.formEmp.value.password,
      nombreComercial: '',
      pais: 'México',
      idEstado: 0,
      idCiudad: 0,
      logo: environment.empresaDefault
    };

    const formData = new FormData();
    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
    formData.append('empresa', blob);

    this.usuarioService.crearCuentaEmpresa(formData).pipe(
      catchError(error => {
        this.enviandoForm = false;
        this.esMensajeSubmit = true;

        const backendMsg = error.error?.message || error.error?.messageError || '';
        if (error.status === 409 || backendMsg === 'EMAIL_EXISTS') {
          const tipo = error.error?.existingAccountType || 'unknown';
          const provider = error.error?.authProvider || 'local';
          this.router.navigate(['/acceder'], { queryParams: { mensaje: 'email_exists', tipo, provider } });
          return throwError(error);
        } else if (backendMsg.includes("correo ya existe")) {
          this.mensajeError = "El correo ya está registrado. Ingrese otro.";
        } else if (backendMsg.includes("temporales")) {
          this.mensajeError = backendMsg;
          this.correoTemporal = true;
        } else {
          this.mensajeError = "Error al crear la cuenta, intenta de nuevo.";
        }

        console.error("Error al registrar empresa:", error);
        return throwError(error);
      })
    ).subscribe(result => {
      this.esMensajeSubmit = true;
      if (result.success) {
        this.mostrarMensajeEmpresa = false;
        this.validandoCampos = false;
        this.mensajeExito = '¡Cuenta creada! Redirigiendo a la verificación de correo...';
        this.enviandoForm = false;
        // Redirigir a /verificar para que confirme su correo antes de iniciar sesión
        setTimeout(() => {
          this.router.navigate(['/verificar'], {
            queryParams: { correo: this.formEmp.value.correo }
          });
        }, 1500);
      } else {
        this.mensajeError = 'Error al crear la cuenta, intenta de nuevo.';
        console.error('Error al crear cuenta para empresa: ', result.messageError);
      }
    });

    this.handleReset();
    this.handleLoad();
    this.reiniciarMensajes();
  }

  async crearCuentaCandidato() {
    this.mostrarMensajeCandidato = true;
    this.validandoCampos = true;

    const correo = this.formCan.value.correo;
    if (correo && this.isDisposableEmail(correo)) {
      this.correoTemporal = true;
      this.esMensajeSubmit = true;
      this.mensajeError = 'Los correos temporales no están permitidos.';
      this.reiniciarMensajes();
      return;
    }
    this.correoTemporal = false;

    if (this.formCan.valid && this.aceptoPrivacidad
      && this.compararPasswords(this.formCan.value.password, this.formCan.value.confirmarPass)) {
      const dataCorreo = await this.existeUsuarioPorCorreo(correo);
      if (dataCorreo) {
        this.correoYaExiste = true;
        this.mensajeError = "Lo sentimos, el correo ya existe. Ingrese otro por favor.";
        this.esMensajeSubmit = true;
      } else {
        this.enviandoForm = true;
        const data = {
          correo: this.formCan.get('correo').value,
          password: this.formCan.get('password').value,
          nombre: this.formCan.get('nombre').value,
          apellidos: this.formCan.get('apellidos').value,
          genero: this.formCan.get('genero').value,
          claveTelefono: this.paisCodigo,
          telefono: this.formCan.get('telefono').value,
          idEstado: this.formCan.get('estado').value,
          idCategoria: this.formCan.get('categoria').value,
          idCiudad: this.formCan.get('ciudad').value,
          pais: this.pais,
          avatar: environment.candidatoDefault
        };

        const formData = new FormData();
        const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
        formData.append('candidato', blob);
        if (this.cv) {
          formData.append('cv', this.cv);
        }

        this.usuarioService.crearCuentaCandidato(formData).pipe(
          catchError(error => {
            let mensajeError = '';
            this.enviandoForm = false;
            this.esMensajeSubmit = true;
            const backendMsg = error.error?.message || error.error?.messageError || '';
            if (error.status === 409 || backendMsg === 'EMAIL_EXISTS') {
              const tipo = error.error?.existingAccountType || 'unknown';
              const provider = error.error?.authProvider || 'local';
              this.router.navigate(['/acceder'], { queryParams: { mensaje: 'email_exists', tipo, provider } });
              return throwError(error);
            } else if (error.status === 0) {
              mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
              mensajeError += `Http error: ${error.message}`;
            } else if (backendMsg.includes("temporales")) {
              this.correoTemporal = true;
              mensajeError = backendMsg;
            } else {
              mensajeError = `Error (código ${error.error.statusCode}): ${error.error.message}`;
            }
            this.mensajeError = 'Error se ha producido un error al crear la cuenta, intentelo más tarde.';
            return throwError(mensajeError);
          })
        ).subscribe(result => {
          this.esMensajeSubmit = result.success;
          if (result.success) {
            this.mostrarMensajeCandidato = false;
            this.validandoCampos = false;
            this.cv = undefined as File;
            this.esconderCiudades = true;
            this.mensajeExito = 'Éxito Se ha creado su cuenta. \n Se ha enviado un código de verificación por correo, Por Favor de revisar su correo con el cual se registro';
            this.ngOnInit();
            this.setValoresPais();
            this.enviandoForm = false;
          } else {
            this.mensajeError = 'Error se ha producido un error al crear la cuenta, intentelo más tarde.';
            console.error('Error al crear cuenta para candidato: ', result.messageError);
          }
        });

        this.handleReset();
        this.handleLoad();
        this.reiniciarMensajes();
      }
      this.reiniciarMensajes();
    } else {
      if (this.formCan.controls.correo.errors || this.formCan.controls.password.errors
        || this.formCan.controls.confirmarPass.errors) {
        this.scrollToElement('acceso');
        this.reiniciarMensajes();
        return;
      }

      if (this.formCan.controls.nombre.errors || this.formCan.controls.apellidos.errors) {
        this.scrollToElement('candidato');
        this.reiniciarMensajes();
        return;
      }

      if (!this.formCan.value.recaptcha) {
        this.esMensajeSubmit = true;
        this.mensajeError = 'Falta que seleccione el recaptcha.';
        this.reiniciarMensajes();
        return;
      }

      if (!this.aceptoPrivacidad) {
        this.esMensajeSubmit = true;
        this.mensajeError = 'Por Favor acepte los términos y condiciones.';
        this.reiniciarMensajes();
        return;
      }
    }
  }

  compararPasswords(password: string, confirmPass: string): boolean {
    if (password != confirmPass) {
      this.esMensajePass = true;
      this.scrollToElement('password');
      setTimeout(() => {
        this.esMensajePass = false;
      }, 3000);
      return false;
    } else {
      this.esMensajePass = false;
      return true;
    }
  }

  cambiarTipoRegistro(): void {
    if (this.tipoRegistro === RolesType.EMPRESAS) {
      this.tipoRegistro = RolesType.CANDIDATOS;
    } else {
      this.tipoRegistro = RolesType.EMPRESAS;
    }
    this.setValoresPais();
  }

  seleccionarTipoRegistro(tipo: string): void {
    this.tipoRegistro = tipo;
    this.setValoresPais();
  }

  handleError(): void {
    this.cdr.detectChanges();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
  }

  scrollToElement(element: string): void {
    document.getElementById(element)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  private reiniciarMensajes(): void {
    setTimeout(() => {
      this.mensajeError = null as string;
      this.esMensajePass = false;
      this.mostrarMensajeEmpresa = false;
      this.mostrarMensajeCandidato = false;
      this.validandoCampos = false;
      this.valorCodigoCoinciden = true;
      this.correoTemporal = false;
      this.correoYaExiste = false;
    }, 3000);

    setTimeout(() => {
      this.esMensajeSubmit = false;
      this.mensajeExito = null as string;
    }, 11500);
  }

  private validarEstadoCiudad(estado: number, ciudad: number): boolean {
    if (this.pais == 'Seleccione un País') {
      this.reiniciarMensajes();
      this.scrollToElement((this.tipoRegistro == "empresa" ? 'razonSocial' : 'apellidos'));
      return false;
    }

    if (this.valorPais == 'MX' && estado == 0) {
      this.reiniciarMensajes();
      this.scrollToElement('pais');
      return false;
    }

    if (this.valorPais == 'MX' && ciudad == 0) {
      this.reiniciarMensajes();
      this.scrollToElement('pais');
      return false;
    }
    return true;
  }

  aceptoTerminoYCondiciones() {
    this.aceptoPrivacidad = !this.aceptoPrivacidad;
  }
}
